module.exports = __webpack_public_path__ + "img/jyly-bg0510-3.65b6f89c.jpg";